module.exports = __webpack_public_path__ + "static/media/chevron-right-gray.2acfd0bd.svg";